import React, { useState } from 'react';
import { AddressContainer } from '@app/basketDetails/style';
import EditAddress from '../EditAddress';
import DeleteAddress from '../DeleteAddress';
import { Modal } from '@design-system/Modal/Modal';
import PropTypes from 'prop-types';

const Card = ({ data, onClick, selectedAddress, locations, selectedLocation }) => {
  const [show, setShow] = useState(false);
  const [hide, setHide] = useState(false);

  const open = () => {
    setShow(!show);
  };

  const close = () => {
    setShow(!show);
  };

  const openModal = () => {
    setHide(!hide);
  };

  const closeModal = () => {
    setHide(!hide);
  };

  return (
    <AddressContainer>
      <Modal show={show} close={close}>
        <EditAddress
          data={data}
          id={data._id}
          locations={locations}
          selectedLocation={selectedLocation}
        />
      </Modal>
      <Modal show={hide} close={closeModal}>
        <DeleteAddress closeModal={closeModal} id={data._id} />
      </Modal>
      <div className="card" key={data._id} onClick={onClick}>
        <div className="card_content">
          <div>
            <h3>{data.full_name}</h3>
            <h4>{data.street_address}</h4>
            <h5>
              {data.city}, {data.state}, {data.country}
            </h5>
            <h6>{data.phone}</h6>
          </div>

          <div style={{ display: 'inline-block' }}>
            <div className="select">
              {data._id === selectedAddress?._id && <div className="inner" />}
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="footer_content">
            <h4 onClick={() => open()}>Edit</h4>
            <h4 onClick={() => openModal()} className="delete">
              Delete
            </h4>
          </div>
        </div>
      </div>
    </AddressContainer>
  );
};

export default Card;

Card.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  selectedAddress: PropTypes.object,
  locations: PropTypes.array,
  selectedLocation: PropTypes.object,
};

Card.defaultProps = {
  onClick: () => {},
  selectedAddress: {},
  locations: [],
  selectedLocation: {},
};
